import { apiClient } from './api';
import type { NormalizedProductListItem, NormalizedProduct, ProductCategory, UpdateProductRequest } from '@wooconnect/shared';

export interface ProductsResponse {
  items: NormalizedProductListItem[];
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

interface ProductsFilters {
  page?: number;
  perPage?: number;
  search?: string;
  status?: string;
  stockStatus?: string;
  category?: number;
}

export async function getProducts(siteId: string, filters: ProductsFilters): Promise<ProductsResponse> {
  const params = new URLSearchParams();
  if (filters.page) params.set('page', String(filters.page));
  if (filters.perPage) params.set('perPage', String(filters.perPage));
  if (filters.search) params.set('search', filters.search);
  if (filters.status) params.set('status', filters.status);
  if (filters.stockStatus) params.set('stock_status', filters.stockStatus);
  if (filters.category) params.set('category', String(filters.category));
  const res = await apiClient.get(`/sites/${siteId}/products?${params}`);
  return res.data.data;
}

export async function getProduct(siteId: string, productId: number): Promise<NormalizedProduct> {
  const res = await apiClient.get(`/sites/${siteId}/products/${productId}`);
  return res.data.data;
}

export async function updateProduct(siteId: string, productId: number, data: UpdateProductRequest): Promise<NormalizedProduct> {
  const res = await apiClient.put(`/sites/${siteId}/products/${productId}`, data);
  return res.data.data;
}

export async function getProductCategories(siteId: string): Promise<ProductCategory[]> {
  const res = await apiClient.get(`/sites/${siteId}/products/categories`);
  return res.data.data;
}
